import { Chip, Stack } from "@mui/material";
import React from "react";

const UsersRolesChips = ({ item }) => {
  const role = item?.role;
  return (
    <Stack direction="row" gap="5px">
      {[role]?.map(({ id, name }) => (
        <Chip
          key={id}
          label={name}
          sx={{
            "& .MuiChip-label": {
              fontSize: 10,
            },
          }}
        />
      ))}
    </Stack>
  );
};

export default UsersRolesChips;
